module.exports = __webpack_public_path__ + "static/media/leafa.9ffe287a.png";